import React from 'react';
import { Box, Button, Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import UnitsVehiclesBlock from './VehiclesBlock';

const SECTION_ACCENT = '#003E7E';

const useStyles = makeStyles(() => ({
  sectionTitle: {
    color: SECTION_ACCENT,
  },
  addButton: {
    backgroundColor: SECTION_ACCENT,
    color: '#fff',
    borderColor: SECTION_ACCENT,
    '&:hover': {
      backgroundColor: '#003266',
      borderColor: '#003266',
    },
  },
}));

const VehiclesSection = ({
  title,
  vehicleTitle,
  type,
  buttonId,
  addButtonText,
  addButtonHandler,
  vehicles,
  control,
  register,
  fieldErrors,
  deleteButtonHandler,
  watch,
  getValues,
  formErrors,
  setValue,
  showActions,
  submitDisabled,
  onSavePermit,
  onCancelPermit,
  isUnitLoaded,
  vehiclesRevision = 0,
}) => {
  const classes = useStyles();
  const isVehicleRecord = (item) =>
    item && typeof item === 'object' && !Array.isArray(item);
  let vehicleNumber = 0;

  return (
    <>
      <Paper elevation={0} variant="outlined">
        <Box
          p={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h5" className={classes.sectionTitle}>
            {title}
          </Typography>
          {showActions ? (
            <Button
              id={buttonId}
              variant="contained"
              className={classes.addButton}
              onClick={addButtonHandler}
              disabled={submitDisabled}
            >
              {addButtonText}
            </Button>
          ) : null}
        </Box>
        {vehicles.length ? (
          <Box px={3} pb={3}>
            <Grid container spacing={2}>
              {vehicles.map((item, index) => {
                if (item === undefined) {
                  return null;
                }

                const cardNumber = ++vehicleNumber;
                const slotKey = item?.id
                  ? `${type}-permit-${item.id}`
                  : `${type}-empty-${vehiclesRevision}-${index}`;

                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={slotKey}
                  >
                    <Paper
                      variant="outlined"
                      style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <UnitsVehiclesBlock
                        fieldId={buttonId}
                        vehicleIndex={index}
                        vehicleNumber={cardNumber}
                        vehicleTitle={vehicleTitle}
                        type={type}
                        vehicle={isVehicleRecord(item) ? item : null}
                        control={control}
                        register={register}
                        fieldErrors={fieldErrors}
                        deleteButtonHandler={deleteButtonHandler}
                        watch={watch}
                        getValues={getValues}
                        formErrors={formErrors}
                        setValue={setValue}
                        showActions={showActions}
                        submitDisabled={submitDisabled}
                        isUnitLoaded={isUnitLoaded}
                        onSave={() => onSavePermit(index)}
                        onCancel={() => onCancelPermit(index)}
                      />
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        ) : null}
      </Paper>
      <Box mb={3} />
    </>
  );
};

export default VehiclesSection;
